import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { AlignItemsProps, DisplayProps, JustifyContentProps, WidthProps } from 'styled-system';
import { alignItems, display, justifyContent, themeGet, width } from 'styled-system';

import { BodyRegularBR1 } from 'common/components/Typography';
import type { ModifiersProps } from 'common/theme/helper';
import { modifiers } from 'common/theme/helper';

const UnstyledBaseNavigationLink = styled(BodyRegularBR1)<
  DisplayProps & AlignItemsProps & JustifyContentProps & ModifiersProps & WidthProps
>`
  ${display};
  ${alignItems};
  ${justifyContent};
  ${modifiers};
  ${width};
  &:hover {
    background-color: ${themeGet('colors.sys.neutral.background.hover')};
  }
  &:active {
    background-color: ${themeGet('colors.sys.neutral.background.active')};
  }
`;

const BaseNavigationLink = (props: ComponentProps<typeof UnstyledBaseNavigationLink>) => (
  <UnstyledBaseNavigationLink
    display="flex"
    alignItems="center"
    as="a"
    justifyContent="space-between"
    pl="sp_16"
    py="sp_4"
    textAlign="left"
    textDecoration="none"
    width={1}
    {...props}
  />
);

export default BaseNavigationLink;
